const manutencao_de_turma = [
  {
    path: "/manutencao-de-turma",
    redirect: "/manutencao-de-turma",
    meta: {
      breadCrumb: "Formação de Turmas - Manutenção de Turma",
    },
    children: [
      {
        path: "/manutencao-de-turma",
        name: "manutencao-de-turma",
        meta: {
          allowedPermissions: ["turma_index"],
        },
        component: () =>
          import("@/views/ManutencaoDeTurma/ManutencaoDeTurmaHome.vue"),
      },
      {
        path: "/manutencao-de-turma/novo",
        name: "manutencao_de_turma_cad",
        meta: {
          allowedPermissions: ["turma_create"],
        },
        component: () =>
          import("@/views/ManutencaoDeTurma/ManutencaoDeTurmaCad.vue"),
      },
      {
        path: "/manutencao-de-turma/detalhes/:id",
        name: "manutencao_de_turma_detalhes",
        meta: {
          allowedPermissions: ["turma_detalhes"],
        },
        component: () =>
          import("@/views/ManutencaoDeTurma/Detalhes/DetalhesTurmas.vue"),
      },
      {
        path: "/manutencao-de-turma/disciplina/:id",
        name: "manutencao_de_turma_disciplina",
        meta: {
          allowedPermissions: ["consulta_disciplinas_turma_show"],
        },
        component: () =>
          import(
            "@/views/ManutencaoDeTurma/Disciplina/ManutencaoDeTurmaDisciplina.vue"
          ),
      },
      {
        path: "/manutencao-de-turma/lancamentos/:id",
        name: "manutencao_de_turma_consulta_lancamentos",
        meta: {
          allowedPermissions: ["consulta_lancamentos_disciplina"],
        },
        component: () =>
          import(
            "@/views/ManutencaoDeTurma/Lancamentos/ManutencaoDeTurmaLancamentosAgrupado.vue"
          ),
      },
      {
        path: "/manutencao-de-turma/lancamentos/:id/tipo/:tipo_id/periodo/:periodo_id",
        name: "manutencao_de_turma_consulta_lancamentos_por_tipo_periodo",
        meta: {
          allowedPermissions: ["consulta_lancamentos_disciplina"],
        },
        component: () =>
          import(
            "@/views/ManutencaoDeTurma/Lancamentos/ManutencaoDeTurmaLancamentos.vue"
          ),
      },
      {
        path: "/manutencao-de-turma/editar/:id",
        meta: {
          allowedPermissions: ["turma_edit"],
        },
        name: "manutencao_de_turma_edit",
        component: () =>
          import("@/views/ManutencaoDeTurma/ManutencaoDeTurmaEdit.vue"),
      },
    ],
  },
];

export { manutencao_de_turma };
